import {Component, Inject, Optional, PLATFORM_ID} from '@angular/core';
import {Router} from "@angular/router";
import {isPlatformBrowser} from "@angular/common";
import {TranslateService} from "@ngx-translate/core";
import {RedirectRouterService} from "@shared/services/web/redirect-router.service";
import {I18nService} from "@app/i18n";
import {REQUEST} from "../../../express.tokens";
import {Request} from 'express';

@Component({
  selector: 'app-redirect-prefix',
  templateUrl: './redirect-prefix.component.html',
  styleUrls: ['./redirect-prefix.component.scss']
})
export class RedirectPrefixComponent {
  constructor(
      private readonly router: Router,
      private redirectRouterService: RedirectRouterService,
      private readonly translateService: TranslateService,
      private readonly i18nService: I18nService,
      @Optional() @Inject(REQUEST) private req: Request,
      @Inject(PLATFORM_ID) private platformId: any
  ) {
    let lang: string;
    if (this.i18nService.hasResolvedFromUrl) {
      // Ya se estaba navegando en un idioma (p.ej. se cambio manualmente con
      // el switcher): respetarlo en vez de volver a detectar el del navegador.
      lang = this.translateService.currentLang;
    } else {
      // Primera visita sin idioma establecido: detectar navigator.language en
      // cliente, o la cabecera Accept-Language en la primera respuesta SSR.
      // Cualquier idioma que no sea ingles cae en español.
      lang = 'es';
      if (isPlatformBrowser(this.platformId)) {
        lang = navigator.language.includes('en') ? 'en' : 'es';
      } else if (this.req?.headers['accept-language']?.includes('en')) {
        lang = 'en';
      }
      this.translateService.use(lang);
    }

    const currentPath = this.router.url;
    const isLanguage =
        currentPath.startsWith('/es/') || currentPath.startsWith('/en/');
    if (!isLanguage) {
      this.redirectRouterService.redireccionExitosa(`/${lang}${currentPath}`);
    } else {
      this.router.navigate([`../page-not-found`]);
    }
  }
}
